import { SiteLayout } from '../components/site/SiteLayout';
import { ServiceLinks } from '../components/site/ServiceLinks';
import { PhoneButton } from '../components/site/PhoneButton';
import { Eyebrow } from '../components/site/PageHero';
import { QuestionnaireButton } from '../components/site/QuestionnaireCta';

export default function Home() {
  return (
    <SiteLayout testid="home-page">
      <section data-testid="home-hero" className="relative overflow-hidden min-h-[calc(100vh-108px)] flex flex-col">
        <div className="absolute inset-0 overflow-hidden">
          <img src="/assets/tree-hero.jpg" alt="Autumn tree on a sunlit hill" className="hero-zoom w-full h-full object-cover object-[50%_55%] no-zoom" />
        </div>
        <div className="absolute inset-0 bg-[#060A17]/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#060A17]/90 via-[#060A17]/50 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-[#060A17] via-[#060A17]/80 to-transparent" />

        <div className="relative z-10 max-w-7xl w-full mx-auto px-5 lg:px-8 pt-20 md:pt-28 pb-16 flex-1 flex flex-col justify-between gap-16">
          <div className="max-w-2xl space-y-7">
            <div className="rise-in"><Eyebrow>Licensed in 19 States Nationwide</Eyebrow></div>
            <h1 data-testid="home-hero-title" className="rise-in font-display text-4xl sm:text-5xl lg:text-7xl font-bold text-white leading-[1.02] tracking-tight" style={{ animationDelay: '100ms' }}>
              Plan with <span className="font-serif-accent italic font-semibold text-orange-400">Confidence</span>
            </h1>
            <p className="rise-in text-base md:text-lg text-slate-200 leading-relaxed max-w-xl" style={{ animationDelay: '200ms' }}>
              Expert retirement consulting and Medicare guidance nationwide. Personalized, transparent, and ethical advice for your financial future.
            </p>
            <div className="rise-in grid sm:flex sm:flex-wrap gap-3" style={{ animationDelay: '280ms' }}>
              <PhoneButton type="financial" size="lg" testid="home-phone-financial" />
              <PhoneButton type="medicare" size="lg" testid="home-phone-medicare" />
            </div>
            <div className="rise-in" style={{ animationDelay: '340ms' }}>
              <QuestionnaireButton testid="home-questionnaire" />
            </div>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-slate-400 mb-5">How can we help?</p>
            <ServiceLinks />
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
